import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
	Row,
	Col,
	Grid,
	Panel,
	PanelBody,
	PanelContainer,
	Button,
	ButtonToolbar
} from '@sketchpixy/rubix';

export default class ContactPage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
   	}

	render() {
		return (
			<PanelContainer>
				<Panel>
					<PanelBody style={{padding: 20, paddingBottom: 25}}>
						<Grid>
							<Row>
								<Col sm={6} className="col-welcome">
									<h4>Vous souhaitez nous contacter ?</h4>
									<hr/>
									<p>
										MONTGOLFIÈRES D’ANJOU<br/>
										Tél. 02 41 404 804<br/>
										Email: manue@montgolfieres.fr
									</p>
								</Col>
								<Col sm={6} className="col-welcome">
									<h4>Un problème technique, une question sur le fonctionnement ?</h4>
									<hr/>
									<p>
										SARL 2PULSE<br/>
										Tél. 02 53 68 12 52 (du lundi au vendredi de 10h à 18h).<br/>
										Email : contact@2pulse.com<br/>
										<a href="http://aerostack.fr">aerostack.fr</a> (en construction)
									</p>
								</Col>
							</Row>
						</Grid>
					</PanelBody>
				</Panel>
			</PanelContainer> 
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/layout/contact.js
 **/